import React from 'react';
import { DOMAIN_TLDS } from '../../modules/constants';

import './tldSelect.scss';

interface Props {
  handleChange: React.FormEventHandler<HTMLSelectElement>;
  loading: boolean;
  tld: string;
}

export const TldSelect: React.FC<Props> = (props: Props) => {
  const { handleChange, tld, loading } = props;

  return (
    <div className="tldselect-component">
      <select
        className="tldselect-component__select"
        onChange={handleChange}
        name="tld"
        value={tld}
        disabled={loading}
      >
        {DOMAIN_TLDS.map((domainTld: string) => {
          return (
            <option key={domainTld} value={domainTld}>
              {domainTld}
            </option>
          );
        })}
      </select>
    </div>
  );
};
